const norm=(value:string|null|undefined)=>String(value||"").toLowerCase().replace(/[^a-z0-9]/g,"");

const requiredSequence:Record<string,string[]>={
  flat:["flat"],
  horizontal:["flat","horizontal"],
  vertical:["flat","horizontal","vertical"],
  overhead:["flat","horizontal","vertical","overhead"],
};

export function qualificationPositionCovered(recorded:string|null|undefined,required:string|null|undefined){
  const text=norm(recorded);
  const target=norm(required);
  if(!target)return true;
  if(text.includes("allposition")||text.includes("allpositions"))return true;
  const sequence=requiredSequence[target];
  if(!sequence)return text.includes(target);
  return sequence.every(position=>text.includes(position));
}

export function qualificationPositionRequirement(required:string|null|undefined){
  const target=norm(required);
  const sequence=requiredSequence[target]||[];
  return sequence.map(x=>x.charAt(0).toUpperCase()+x.slice(1)).join(" → ");
}
